/**
 * Stylesheet portale paziente (PR4).
 *
 * Sottoinsieme di src/app/index.css: solo font Inter (base) +
 * Material Symbols (per progress check icon). Niente Plus Jakarta
 * Sans (non serve per UI semplice del portale), niente gradients
 * gestionale.
 */

@import '@fontsource/inter/400.css';
@import '@fontsource/inter/500.css';
@import '@fontsource/inter/600.css';
@import '@fontsource/inter/700.css';
@import 'material-symbols/outlined.css';

@tailwind base;
@tailwind components;
@tailwind utilities;

html {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

body {
  background-color: #f7f7f8;
  color: #1a1a1a;
  margin: 0;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.material-symbols-outlined {
  font-variation-settings:
    'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 24;
}
